import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	flagCopyLinkNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-copy-link-no-translate',
		defaultMessage: 'Copy Link',
		description: 'Flag copy link button.',
	},
	flagCopiedNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-copied-no-translate',
		defaultMessage: 'Link copied',
		description: 'Flag successful copied message.',
	},
	flagTitleNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-title-no-translate',
		defaultMessage: 'Your Loom video is ready!',
		description: 'Copy link flag title',
	},
	flagDescriptionNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-recording-button.flag-description-no-translate',
		defaultMessage: 'Copy the link to share it with your team.',
		description: 'Copy link flag description',
	},
});

export default messages;
